import moment from "moment";
import { Base } from "ui/Scripts/source/framework/base";
import { ICalendarTaskDayItem, ICalendarTaskDayItemItem } from "./CalendarTaskListItem";
import { ICalendarTaskItem } from "ui/Scripts/source/models/calendarTask/calendarTaskItem";

const getYearTitle = (yearNumber: number): ICalendarTaskDayItem => {
    return {
        id: `year-${yearNumber}`,
        dateLabel: "",
        dayLabel: "",
        dayNumber: yearNumber.toString(),
        events: [],
    };
};

const getWeekTitle = (weekNumber: number, yearNumber: number): ICalendarTaskDayItem => {
    return {
        id: `week-${weekNumber}-${yearNumber}`,
        dateLabel: "",
        dayLabel: "",
        dayNumber: weekNumber.toString(),
        events: [],
    };
};

export const getEventsByDate = (events: ICalendarTaskDayItemItem[]): ICalendarTaskDayItem[] => {
    const result: ICalendarTaskDayItem[] = [];
    let lastYearNumber = 0;
    let lastWeekNumber = 0;
    let hasMultipleYears = false;

    events.forEach((event) => {
        const startDate = Base.timeToDateStr(event.startDate);
        const dayItem = result.find((item) => item.id === startDate);
        if (!dayItem) {
            const mStartDate = moment(event.startDate);
            if (mStartDate.year() !== lastYearNumber) {
                hasMultipleYears = lastWeekNumber > 0;
                lastYearNumber = mStartDate.year();
                result.push(getYearTitle(lastYearNumber));
                lastWeekNumber = mStartDate.week();
                result.push(getWeekTitle(lastWeekNumber, lastYearNumber));
            } else if (mStartDate.week() !== lastWeekNumber) {
                lastWeekNumber = mStartDate.week();
                result.push(getWeekTitle(lastWeekNumber, lastYearNumber));
            }
            if (mStartDate.week() !== lastWeekNumber || mStartDate.year() !== lastYearNumber) {
                lastWeekNumber = mStartDate.week();
                lastYearNumber = mStartDate.year();
                result.push({
                    id: `week-${lastWeekNumber}-${lastYearNumber}`,
                    dateLabel: "",
                    dayLabel: "",
                    dayNumber: lastWeekNumber.toString(),
                    events: [],
                });
            }
            result.push({
                id: startDate,
                dateLabel: `${mStartDate.format("MMMM")} ${mStartDate.format("YYYY")}`,
                dayLabel: mStartDate.format("dddd"),
                dayNumber: mStartDate.format("D"),
                events: [{ ...event }],
            });
        } else {
            dayItem.events.push({ ...event });
        }
    });

    if (!hasMultipleYears && result.length > 0) {
        //Remove year titles if there is only one year in the list
        return result.filter((item) => !item.id.includes("year-"));
    }

    return result;
};

export const getEventsByDay = (items: ICalendarTaskItem[], startDate: number, endDate: number) => {
    const result: ICalendarTaskDayItemItem[] = [];
    const mListStartDate = startDate ? moment(startDate) : null;
    const mListEndDate = endDate ? moment(endDate) : null;
    //console.log("list dates", mListStartDate.format("YYYY-MM-DD"), mListEndDate.format("YYYY-MM-DD"));
    for (const item of items) {
        let mStartDate = moment(item.startDate);
        const mEndDate = moment(item.endDate);
        //console.log("event", item.startDate, item.endDate, Base.timeToDateTimeStr(item.startDate), Base.timeToDateTimeStr(item.endDate), mStartDate.format("YYYY-MM-DD"), mEndDate.format("YYYY-MM-DD"));
        //Just start date specified or start date and end date are the same day
        if (!item.endDate || mStartDate.isSame(mEndDate, "date")) {
            result.push({ ...item, startsEarlierDate: false, endsLaterDate: false });
            continue;
        }
        //End date is specified and start date is before end date
        if (mStartDate.isBefore(mEndDate, "date") && (!mListEndDate || mStartDate.isBefore(mListEndDate, "date"))) {
            if (mListStartDate && mStartDate.isBefore(mListStartDate, "date")) {
                mStartDate = mListStartDate.clone().startOf("day");
                result.push({ ...item, startsEarlierDate: true, endsLaterDate: true, startDate: parseInt(mStartDate.format("x")), allDay: item.allDay || !mStartDate.isSame(mEndDate, "date") });
            } else {
                result.push({ ...item, startsEarlierDate: false, endsLaterDate: true });
            }
            const mDate = mStartDate.clone().startOf("day");
            while (!mDate.isSame(mEndDate, "date")) {
                mDate.add(1, "days");
                //console.log("mDate", mDate.format("YYYY-MM-DD"));
                const startDateIsSameAsEndDate = mDate.isSame(mEndDate, "date");
                if (!mListEndDate || mDate.isBefore(mListEndDate, "date")) {
                    result.push({
                        ...item,
                        startsEarlierDate: true,
                        endsLaterDate: !startDateIsSameAsEndDate,
                        startDate: parseInt(mDate.format("x")),
                        allDay: item.allDay || !startDateIsSameAsEndDate,
                    });
                } else {
                    break;
                }
            }
            continue;
        }
        //End date is specified and start date is after end date: ERROR CONDITION
        if (mStartDate.isAfter(mEndDate, "date")) {
            if ((!mListStartDate || mStartDate.isSame(mListStartDate, "date") || mStartDate.isAfter(mListStartDate, "date")) && (!mListEndDate || mListEndDate.isAfter(mStartDate, "date"))) {
                //Start date is in list range
                result.push({ ...item, startsEarlierDate: false, endsLaterDate: true });
            } else if ((!mListStartDate || mEndDate.isAfter(mListStartDate, "date")) && (!mListEndDate || mListEndDate.isAfter(mEndDate, "date"))) {
                //End date is in list range
                result.push({ ...item, startsEarlierDate: true, endsLaterDate: false, startDate: parseInt(mEndDate.format("x")) });
            }
        }
    }
    return result;
};